import React from 'react';
import carDamage from "../../media/carDamage.png";
interface Props {
    damage?: CarDamage[];
    addDamage: (data: CarDamage) => void;
    removeDamage: (id: string) => void;
}
const CarDamageHandler: React.FC<Props> = (props) => {
    const image = React.useRef<HTMLDivElement>(null);
    const handleImageClick = (event: React.MouseEvent<HTMLDivElement>, isBeforeImage: boolean) => {
        const imageContainer = isBeforeImage ? image.current : image.current;
        if (!imageContainer) return;

        const rect = imageContainer.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const newMarker: CarDamage = {
            x,
            y,
            id: `marker-${Date.now()}`,
            date: new Date(),
        };
        props.addDamage(newMarker);
    };

    // Remove marker when clicked
    const removeMarker = (markerId: string, isBeforeImage: boolean) => {
        props.removeDamage(markerId);
    };
    return (
        <div className='loanCar'>
            <div
                className="image-container"
                ref={image}
                onClick={(e) => handleImageClick(e, false)}
            >
                <img
                    src={carDamage}
                    alt="Efter udlevering"
                    className="image"
                />
                {props.damage && props.damage.map((marker) => (
                    <div
                        key={marker.id}
                        className="damage-marker"
                        style={{
                            left: `${marker.x}px`,
                            top: `${marker.y}px`
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            removeMarker(marker.id, false);
                        }}
                        title="Klik for at fjerne"
                    />
                ))}
            </div>
        </div>
    );
};

export default CarDamageHandler;